import { countryList } from "./countryList";

export const stringShorter = (item, len) =>
  item.substring(0, item.length - len);

export const groupedContent = {
  "Reset Commands": [
    {
      command: "RSTDC",
      title: "Reset Commands",
      description: "Reset energy logging interval on DCU",
    },
    {
      command: "RST01",
      title: "Reset Commands",
      description: "Reset energy logging interval on device",
    },
    {
      command: "RST03",
      title: "Reset Commands",
      description: "Reset meter interruption duration count",
    },
    { command: "RST04", title: "Reset Commands", description: "Reset SAIFI" },
  ],
  "Power Management": [
    { command: "TON", title: "Turn on", description: "Turn on meter" },
    { command: "OFF", title: "Turn off", description: "Turn off meter" },
    { command: "LUP", title: "Loop timer", description: "loop timer" },
    {
      command: "CON",
      title: "Schedule connection",
      description: "Turn on meter",
    },
    {
      command: "DIS",
      title: "Schedule disconnection",
      description: "Turn off meter",
    },
    // {
    //   command: "PSS00",
    //   title: "Power-on on supply",
    //   description: "Power-on on supply",
    // },
    // {
    //   command: "PSS01",
    //   title: "Power-off on supply",
    //   description: "Power-off on supply",
    // },
    // {
    //   command: "PSS05",
    //   title: "Power supply status",
    //   description: "Power supply status",
    // },
  ],
  //   "Meter Management": [
  //     {
  //       command: "CMC",
  //       title: "Create meter class",
  //       description: "Create meter class",
  //     },
  //     {
  //       command: "DMC",
  //       title: "Meter Management",
  //       description: "Delete meter class",
  //     },
  //     {
  //       command: "AMC",
  //       title: "Meter Management",
  //       description: "Add meter class",
  //     },
  //     {
  //       command: "MCE",
  //       title: "Meter Management",
  //       description: "Meter class enquiry",
  //     },
  //   ],
  "Energy Inquiry": [
    {
      command: "SDE",
      title: "SAIDI",
      description: "Request for meter interruption duration",
    },
    {
      command: "SFE",
      title: "SAIFI",
      description: "Request for meter interruption count",
    },
  ],
  "Plan command": [
    {
      command: "RST05",
      title: "Clear Plan Payment on Meter",
      description: "Clear payment plans on meter",
    },
    {
      command: "RST07",
      title: "Diable biling on meter",
      description: "Disable billing on meter",
    },
  ],
  "Meter balance": [
    {
      command: "LEN",
      title: "Last recharge enquiry",
      description: "Request for the last recharge made on meter",
    },
    {
      command: "BEN",
      title: "Energy Inquiry",
      description: "Request for the current balance on meter",
    },
  ],
};

export const metergroupedContent = {
  // "Reset Commands": [
  //   {
  //     command: "RSTDC",
  //     title: "Reset Commands",
  //     description: "Reset energy logging interval on DCU",
  //   },
  //   {
  //     command: "RST01",
  //     title: "Reset Commands",
  //     description: "Reset energy logging interval on device",
  //   },
  //   {
  //     command: "RST03",
  //     title: "Reset Commands",
  //     description: "Reset meter interruption duration count",
  //   },
  //   { command: "RST04", title: "Reset Commands", description: "Reset SAIFI" },
  // ],
  "Power Management": [
    // { command: "TON", title: "Turn on", description: "Turn on meter" },
    // { command: "OFF", title: "Turn off", description: "Turn off meter" },
    { command: "LUP", title: "Loop timer", description: "loop timer" },
    {
      command: "CON",
      title: "Schedule connection",
      description: "Turn on meter",
    },
    {
      command: "DIS",
      title: "Schedule disconnection",
      description: "Turn off meter",
    },
    // {
    //   command: "PSS00",
    //   title: "Power-on on supply",
    //   description: "Power-on on supply",
    // },
    // {
    //   command: "PSS01",
    //   title: "Power-off on supply",
    //   description: "Power-off on supply",
    // },
    // {
    //   command: "PSS05",
    //   title: "Power supply status",
    //   description: "Power supply status",
    // },
  ],
  //   "Meter Management": [
  //     {
  //       command: "CMC",
  //       title: "Create meter class",
  //       description: "Create meter class",
  //     },
  //     {
  //       command: "DMC",
  //       title: "Meter Management",
  //       description: "Delete meter class",
  //     },
  //     {
  //       command: "AMC",
  //       title: "Meter Management",
  //       description: "Add meter class",
  //     },
  //     {
  //       command: "MCE",
  //       title: "Meter Management",
  //       description: "Meter class enquiry",
  //     },
  //   ],
  // "Energy Inquiry": [
  //   {
  //     command: "SDE",
  //     title: "SAIDI",
  //     description: "Request for meter interruption duration",
  //   },
  //   {
  //     command: "SFE",
  //     title: "SAIFI",
  //     description: "Request for meter interruption count",
  //   },
  // ],
  // "Plan command": [
  //   {
  //     command: "RST05",
  //     title: "Clear Plan Payment on Meter",
  //     description: "Clear payment plans on meter",
  //   },
  //   {
  //     command: "RST07",
  //     title: "Diable biling on meter",
  //     description: "Disable billing on meter",
  //   },
  // ],
  // "Meter balance": [
  //   {
  //     command: "LEN",
  //     title: "Last recharge enquiry",
  //     description: "Request for the last recharge made on meter",
  //   },
  //   {
  //     command: "BEN",
  //     title: "Energy Inquiry",
  //     description: "Request for the current balance on meter",
  //   },
  // ],
};

export const touFormatter = (item) =>
  item
    .substring(1)
    .split("#")
    .map((item) => {
      return {
        pt: parseInt(item.substring(item.length - 3, item.length)) + "%",
        st:
          item.substring(0, 6).substring(0, 2) +
          ":" +
          item.substring(0, 6).substring(2, 4) +
          ":" +
          item.substring(0, 6).substring(4, 6),
        et:
          item.substring(6, 13).substring(0, 2) +
          ":" +
          item.substring(6, 13).substring(2, 4) +
          ":" +
          item.substring(6, 13).substring(4, 6),
      };
    });

export const NotificationFormatter = (item) => {
  switch (item) {
    case "TON":
      return "Turn on";
    case "CMC":
      return "Create meter class";
    case "ENE":
      return "Clear credit";
    case "RST05":
      return "Clear plan on meter";
    case "DMC":
      return "Delete meter class";
    case "SDE":
      return "SAIDi enquiry";
    case "SFE":
      return "SAIFI enquiry";
    case "RSTDC":
      return "Reset energy logging interval on dcu";
    case "RST01":
      return "Reset energy logging interval on device";
    case "RST03":
      return "Reset SAIDI ";
    case "RST04":
      return "Reset SAIFI ";
    case "RST10":
      return "Erase control command.";
    case "RST14":
      return "Active panel source.";
    case "OFF":
      return "Turn off";
    case "INT":
      return "Update logging interval";
    case "INT00":
      return "Request for energy logging interval";
    case "LUP":
      return "Loop timer";
    case "RST11":
      return "Clear commands on meter";
    case "APP":
      return "Measure energy by APP. power";
    case "REP":
      return "Measure energy by real power";
    case "PSS05":
      return "Power supply status";
    case "PSS00":
      return "Power-on on supply ";
    case "PSS01":
      return "Power-off on supply ";
    case "CON":
      return "Schedule connection";
    case "DIS":
      return "Schedule disconnection";
    case "CTP":
      return "Clear hardware temper";
    case "AMC":
      return "Add meter class";
    case "CLR":
      return "Clear command on meter";
    case "GTP":
      return "Get hardware temper status";
    case "ENB":
      return "Daily power plan";
    case "ECA":
      return "Created Daily energy limit";
    case "END":
      return "Untimed Energy";
    case "ENC":
      return "Cummulative energy plan";
    case "ENA":
      return "Cummulative energy plan";
    case "ECC":
      return "Created cummulative energy limit";
    case "MCE":
      return "Meter class enquiry.";
    case "RUP":
      return "Real time update";
    case "LEN":
      return "Last recharge enquiry";
    case "BEN":
      return "Balance enquiry";
    case "GEN":
      return "Power state of device";
    case "PSS03":
      return "Power up sequence";
    case "PSS04":
      return "Power up sequence";
    case "RST13":
      return "Default input source.";
    case "RST15":
      return "Power state on panel";
    case "RST16":
      return "Panel source selection";
    default:
      return "Unknown Command";
  }
};

export const NotificationFormatterNew = (item) => {
  switch (item) {
    case "TON":
      return {
        type: "TON",
        caption: "Turn On",
        description: "Meter has been turned on successfully.",
      };
    case "CMC":
      return {
        type: "CMC",
        caption: "Create Meter Class",
        description: "A new meter class has been created.",
      };
    case "RST05":
      return {
        type: "RST05",
        caption: "Clear plan on meter",
        description: "All plans on meter have being clear",
      };
    case "DMC":
      return {
        type: "DMC",
        caption: "Delete Meter Class",
        description: "The meter class has been deleted successfully.",
      };
    case "SDE":
      return {
        type: "SDE",
        caption: "SAIDI Enquiry",
        description: "SAIDI enquiry request was processed.",
      };
    case "ENE":
      return {
        type: "ENE",
        caption: "Clear credit",
        description: "Credit has been cleared successfully.",
      };
    case "SFE":
      return {
        type: "SFE",
        caption: "SAIFI Enquiry",
        description: "SAIFI enquiry request was processed.",
      };
    case "RSTDC":
      return {
        type: "RSTDC",
        caption: "Reset DCU Logging Interval",
        description: "Energy logging interval on DCU has been reset.",
      };
    case "RST01":
      return {
        type: "RST01",
        caption: "Reset Device Logging Interval",
        description: "Energy logging interval on the device has been reset.",
      };
    case "RST03":
      return {
        type: "RST03",
        caption: "Reset SAIDI",
        description: "SAIDI has been reset successfully.",
      };
    case "RST04":
      return {
        type: "RST04",
        caption: "Reset SAIFI",
        description: "SAIFI has been reset successfully.",
      };
    case "RST10":
      return {
        type: "RST10",
        caption: "Erase Control Command",
        description: "Control command has been erased.",
      };
    case "RST11":
      return {
        type: "RST11",
        caption: "Erase Meter Command",
        description: "All command on meter has been cleared.",
      };
    case "RST14":
      return {
        type: "RST14",
        caption: "Activate Panel Source",
        description: "Panel source has been activated.",
      };
    case "OFF":
      return {
        type: "OFF",
        caption: "Turn Off",
        description: "Device has been turned off successfully.",
      };
    case "INT":
      return {
        type: "INT",
        caption: "Update Logging Interval",
        description: "Logging interval has been updated.",
      };
    case "INT00":
      return {
        type: "INT00",
        caption: "Energy Logging Interval Request",
        description: "Requested for energy logging interval.",
      };
    case "LUP":
      return {
        type: "LUP",
        caption: "Loop Timer",
        description: "Loop timer has been updated.",
      };
    case "APP":
      return {
        type: "APP",
        caption: "Measure Energy by APP Power",
        description: "Energy measured using apparent power.",
      };
    case "REP":
      return {
        type: "REP",
        caption: "Measure Energy by Real Power",
        description: "Energy measured using real power.",
      };
    case "PSS05":
      return {
        type: "PSS05",
        caption: "Power Supply Status",
        description: "Power supply status retrieved.",
      };
    case "PSS00":
      return {
        type: "PSS00",
        caption: "Power On Supply",
        description: "Power has been turned on for the supply.",
      };
    case "PSS01":
      return {
        type: "PSS01",
        caption: "Power Off Supply",
        description: "Power has been turned off for the supply.",
      };
    case "CON":
      return {
        type: "CON",
        caption: "Schedule Connection",
        description: "Connection has been scheduled successfully.",
      };
    case "DIS":
      return {
        type: "DIS",
        caption: "Schedule Disconnection",
        description: "Disconnection has been scheduled successfully.",
      };
    case "CTP":
      return {
        type: "CTP",
        caption: "Clear Hardware Tamper",
        description: "Hardware tamper has been cleared.",
      };
    case "AMC":
      return {
        type: "AMC",
        caption: "Add Meter Class",
        description: "A new meter class has been added.",
      };
    case "CLR":
      return {
        type: "CLR",
        caption: "Clear Meter Command",
        description: "Meter command has been cleared.",
      };
    case "GTP":
      return {
        type: "GTP",
        caption: "Get Hardware Tamper Status",
        description: "Hardware tamper status retrieved.",
      };
    case "ENB":
      return {
        type: "ENB",
        caption: "Daily Power Plan",
        description: "Daily power plan has been created.",
      };
    case "ECA":
      return {
        type: "ECA",
        caption: "Daily Energy Limit",
        description: "A daily energy limit has been created.",
      };
    case "END":
      return {
        type: "END",
        caption: "Untimed Energy",
        description: "Untimed energy plan has been processed.",
      };
    case "ENC":
      return {
        type: "ENC",
        caption: "Cumulative Energy Plan",
        description: "Cumulative energy plan has been set.",
      };
    case "ENA":
      return {
        type: "ENA",
        caption: "Energy Plan",
        description: "Your energy purchase was successful.",
      };
    case "ECC":
      return {
        type: "ECC",
        caption: "Cumulative Energy Limit",
        description: "A cumulative energy limit has been created.",
      };
    case "MCE":
      return {
        type: "MCE",
        caption: "Meter Class Enquiry",
        description: "Meter class enquiry has been processed.",
      };
    case "RUP":
      return {
        type: "RUP",
        caption: "Real-Time Update",
        description: "Real-time update has been performed.",
      };
    case "LEN":
      return {
        type: "LEN",
        caption: "Last Recharge Enquiry",
        description: "Last recharge enquiry has been processed.",
      };
    case "BEN":
      return {
        type: "BEN",
        caption: "Balance Enquiry",
        description: "Balance enquiry has been processed.",
      };
    case "GEN":
      return {
        type: "GEN",
        caption: "Power State",
        description: "Power state of the device retrieved.",
      };
    case "PSS03":
      return {
        type: "PSS03",
        caption: "Power Up Sequence",
        description: "Power-up sequence initiated.",
      };
    case "PSS04":
      return {
        type: "PSS04",
        caption: "Power Up Sequence",
        description: "Power-up sequence initiated.",
      };
    case "RST13":
      return {
        type: "RST13",
        caption: "Default Input Source",
        description: "Default input source has been set.",
      };
    case "RST15":
      return {
        type: "RST15",
        caption: "Power State on Panel",
        description: "Power state on the panel updated.",
      };
    case "RST16":
      return {
        type: "RST16",
        caption: "Panel Source Selection",
        description: "Panel source has been selected.",
      };
    default:
      return {
        type: "UNKNOWN",
        caption: "Unknown Command",
        description: "The command provided is not recognized.",
      };
  }
};

export const filterDouble = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};

export const alertFormatter = (item) => {
  if (item == "PHASE_LOSS") {
    return {
      title: "Phase Loss Detected",
      caption:
        "A phase loss has been detected on the meter. This may indicate an issue with the power supply or wiring.",
    };
  } else if (item == "PHASE_RESTORE") {
    return {
      title: "Phase Restored",
      caption:
        "The phase that was previously lost has been restored on the meter. Power supply is now stable.",
    };
  } else if (item == "OVERVOLTAGE") {
    return {
      title: "Over Voltage Alert",
      caption:
        "The meter has detected an over voltage condition. This could damage connected equipment if not addressed.",
    };
  } else if (item == "UNDERVOLTAGE") {
    return {
      title: "Under Voltage Alert",
      caption:
        "The meter has detected an under voltage condition. This may cause equipment to malfunction.",
    };
  } else if (item == "OVERCURRENT") {
    return {
      title: "Over Current Alert",
      caption:
        "The meter has detected an over current condition. This could indicate a short circuit or overload.",
    };
  } else if (item == "UNDERCURRENT") {
    return {
      title: "Under Current Alert",
      caption:
        "The meter has detected an under current condition. This may indicate a load disconnection or fault.",
    };
  } else if (item == "POWER_OVERLIMIT") {
    return {
      title: "Power Overlimit Alert",
      caption:
        "The power consumption on the meter has exceeded the predefined limit. Please check the load.",
    };
  } else if (item == "CREDIT_EXPIRED") {
    return {
      title: "Credit Expired",
      caption:
        "The credit on the meter has expired. Please recharge to restore power.",
    };
  } else if (item == "CUMULATIVE_ENERGY_OVERLIMIT") {
    return {
      title: "Cumulative Energy Overlimit",
      caption:
        "The cumulative energy consumption on the meter has exceeded the allowed limit.",
    };
  } else if (item == "DAILY_POWER_OVERLIMIT") {
    return {
      title: "Daily Power Overlimit",
      caption:
        "The daily power consumption on the meter has exceeded the predefined limit.",
    };
  } else if (item == "ENA") {
    return {
      title: "Daily Energy Limit Recharge",
      caption:
        "A daily energy limit plan has been successfully activated on the meter.",
    };
  } else if (item == "ENB") {
    return {
      title: "Daily Power Limit Recharge",
      caption:
        "A daily power limit plan has been successfully activated on the meter.",
    };
  } else if (item == "ENC") {
    return {
      title: "Cumulative Energy Limit Recharge",
      caption:
        "A cumulative energy limit plan has been successfully activated on the meter.",
    };
  } else if (item == "END") {
    return {
      title: "Unlimited Energy Recharge",
      caption:
        "An unlimited energy plan has been successfully activated on the meter.",
    };
  } else if (item == "HARDWARE_TAMPER") {
    return {
      title: "Hardware Tampering Detected",
      caption:
        "The meter has detected unauthorized tampering. Please inspect the meter for any signs of interference.",
    };
  } else if (item == "RST08") {
    return {
      title: "Billing Activated",
      caption: "Billing has been successfully activated on the meter.",
    };
  } else if (item == "RST07") {
    return {
      title: "Billing Deactivated",
      caption: "Billing has been successfully deactivated on the meter.",
    };
  } else {
    return {
      title: "",
      caption: "",
    };
  }
};

export const dateFilter = [
  {
    id: 1,
    title: "Today",
    tag: "today",
  },
  {
    id: 2,
    title: "This week",
    tag: "week",
  },
  {
    id: 3,
    title: "This month",
    tag: "month",
  },
  {
    id: 4,
    title: "This year",
    tag: "year",
  },
];

export function findCenterPoint(coordinates) {
  if (coordinates.length === 0) {
    return null;
  }
  let sumLat = 0;
  let sumLng = 0;
  for (const coord of coordinates) {
    sumLat += +coord[0];
    sumLng += +coord[1];
  }
  const centerLat = sumLat / coordinates.length;
  const centerLng = sumLng / coordinates.length;
  return [centerLat, centerLng];
}

export const durationValues = [
  { value: "day", label: "Day(s)" },
  { value: "week", label: "Week(s)" },
  { value: "month", label: "Month(s)" },
  { value: "year", label: "Year(s)" },
];

export const durationValuesOld = [
  { value: "day(s)", label: "Day(s)" },
  { value: "week(s)", label: "Week(s)" },
  { value: "month(s)", label: "Month(s)" },
  { value: "year(s)", label: "Year(s)" },
];

export const tableCustomStyles = {
  headRow: {
    style: {
      color: "black",
      backgroundColor: "#ecf4f9",
    },
  },
  rows: {
    style: {
      color: "STRIPEDCOLOR",
      backgroundColor: "STRIPEDCOLOR",
    },
    stripedStyle: {
      color: "NORMALCOLOR",
      backgroundColor: "NORMALCOLOR",
    },
  },
};

export const revenueFields = [
  {
    id: 1,
    key: "transactionCount",
    title: "Transaction count",
  },
  {
    id: 2,
    key: "totalRevenue",
    title: "Total Revenue",
  },
  {
    id: 3,
    key: "totalCommission",
    title: "Total Commission",
  },
  {
    id: 4,
    key: "netRevenue",
    title: "Net Revenue",
  },
  {
    id: 5,
    key: "totalKWh",
    title: "Total Unit Assigned (KWh)",
  },
  {
    id: 6,
    key: "avgTransactionValue",
    title: "Average Transaction Value",
  },
];

export const formatTransactionTitle = (title) => {
  switch (title) {
    case "transactionCount":
      return "Transaction Count";
    case "totalRevenue":
      return "Total Revenue";
    case "totalCommission":
      return "Total Commission";
    case "netRevenue":
      return "Net Revenue";
    case "totalKWh":
      return "Total Unit Assigned (KWh)";
    case "totalSales":
      return "Total Revenue";
    case "avgTransactionValue":
      return "Avg Transaction Value";
    default:
      break;
  }
};

export const formatUnits = (title) => {
  switch (title) {
    case "transactionCount":
      return "count";
    case "totalRevenue":
      return "sales";
    case "totalCommission":
      return "sales";
    case "netRevenue":
      return "sales";
    case "totalKWh":
      return "units";
    default:
      break;
  }
};

// Step 1: Build a hash map for quick lookups (O(N))
export const currencyMap = Object.entries(countryList).reduce(
  (acc, [name, details]) => {
    acc[details["Currency Code"]] = { name, ...details };
    return acc;
  },
  {}
);

/**
 * Function to find a country by currency code in O(1) time
 * @param {string} currencyCode - Currency code to search for
 * @returns {Object | false} - Returns the country object or false if not found
 */
export const findCountryByCurrency = (currencyCode) => {
  return currencyMap[currencyCode] || false;
};

export function getCountryDetails(countryName) {
  return countryList[countryName] || null;
}
